<template>
  <div
      v-if="restricted"
      class="bypass">
    <div style="width: fit-content; padding-bottom: 32px;">
      <div class="warning-img">
        <img
            src="../../../assets/warning-icon.svg"
            style="height: 48px; width: 48px; margin-bottom: 8px;">
      </div>
      <div class="heading">
        Replacement Eligibility Restriction Detected
      </div>
      <div class="sub-heading">
        One or more restrictions prevent this action:
      </div>

      <device-restriction-details
          class="restriction-list"
          :warranty-ends-at="warrantyEndsAt"
          :oow-reason="oowReason"
          :restrictions="restrictions" />
    </div>
    <el-card class="device-card">
      <div
          class="device-image">
        <DeviceImage
            :device="device" />
      </div>
      <div class="device-content">
        <div class="device-name">
          {{ device.profile.product.description }}
        </div>
        <div class="device-mac-id">
          {{ displayableDeviceId }}
        </div>
        <div class="device-status">
          <span v-if="eligibility.isInWarranty">Out of warranty</span>
          <span v-else>Restricted</span>
          /
          <span>Not eligible for replacement.</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import DeviceImage from "../../../components/Shared/DeviceImage.vue";
import DeviceRestrictionDetails from "@/components/Shared/DeviceRestrictionDetails.vue";
import { DeviceWarrantyAndEligibilityPolicy } from "@/helpers/DeviceWarrantyAndEligibilityPolicy";

export default {
  name: "EligibilityCheck",
  components: { DeviceRestrictionDetails, DeviceImage },
  props: {
    device: {
      type: Object,
      required: true,
    },
    eligibility: {
      type: Object,
      default: () => {
        return DeviceWarrantyAndEligibilityPolicy.create(null);
      },
    },
  },
  computed: {
    displayableDeviceId() {
      const macAddress = this.device?.mac_address;
      const hardwareId = this.device?.hardware_id;
      const profileDeviceId = this.device?.device_id;
      switch (true) {
        case !!macAddress:
          return `MAC ID: ${macAddress}`;
        case !!hardwareId:
          return `ID: ${hardwareId}`;
        case !!profileDeviceId:
          return `ID: ${profileDeviceId}`;
        default:
          return "ID: ";
      }
    },
    restricted() {
      return this.restrictions.length > 0;
    },
    restrictions() {
      return this.eligibility?.isNullObject
        ? []
        : this.eligibility.replacement.ineligibilityReasons;
    },
    oowReason() {
      return this.eligibility.warranty.notes;
    },
    warrantyEndsAt() {
      return this.eligibility.warranty.standardExpiration;
    },
  },
};
</script>

<style>
.bypass {
  color: #424242;
  font-family: Equip;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;

  .heading {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.4em;
  }

  .sub-heading {
    font-size: 20px;
    font-weight: 500;
    line-height: 1em;
    margin-bottom: 1.7em;
    color: #d71b00;
  }
  .oow-support-page {
    color: #1476ad;
    font-family: Equip;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration-line: underline;
  }
  .warning-img {
    flex-direction: column;
    align-self: flex-start;
    display: flex;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .device-card {
    margin-top: 16px;
    box-shadow: none !important;
    align-items: stretch;
    padding: 8px 24px 8px 8px;
    display: flex;
    flex-direction: row;
    el-card {
      width: 988px !important;
      box-shadow: none !important;
    }
    .el-card__body {
      margin: 0px !important;
    }
    .device-content {
      margin-left: 8px;
      padding-bottom: 8px;
      padding-top: 8px;
      float: right;
      line-height: 24px;
      font-style: normal;
      font-family: Equip, serif;
      .device-mac-id {
        color: #6e6e6e;
        font-size: 14px;
        font-weight: 400;
        padding-bottom: 10px;
      }
      .device-status {
        color: #f1670d;
        font-size: 14px;
        font-weight: 400;
      }
      .device-name {
        color: #424242;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .device-image {
      float: left;
      height: 80px;
      width: 80px;
      margin-right: 0px !important;
      img {
        height: 80px;
        width: 80px;
      }
    }
  }
}
</style>
